var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "AppModal",
    { attrs: { id: _vm.id, options: _vm.options, fullscreen: _vm.$ui.mobile } },
    [
      _c("div", { staticClass: "flex flex-col flex-grow desktop:flex-row" }, [
        _vm.movie.posterUrl
          ? _c(
              "div",
              {
                staticClass:
                  "relative -mx-4 -mt-4 mb-2 p-4 desktop:m-0 desktop:p-0"
              },
              [
                _vm.$ui.mobile
                  ? [
                      _c(
                        "button",
                        {
                          staticClass:
                            "absolute top-0 right-0 m-4 p-2 rounded-full z-10 bg-white-overlay",
                          attrs: { type: "button" },
                          on: { click: _vm.close }
                        },
                        [
                          _c("BaseIcon", {
                            staticClass: "w-4 h-4 text-gray-800",
                            attrs: { name: "close" }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "absolute inset-0 opacity-gradient-top"
                        },
                        [
                          _c("div", {
                            staticClass: "absolute inset-0 bg-gray-300"
                          }),
                          _c("div", {
                            staticClass: "absolute inset-0 opacity-75 bg-cover",
                            style: {
                              filter: "blur(.5px)",
                              backgroundImage:
                                "url('" + _vm.movie.posterUrl + "')"
                            }
                          })
                        ]
                      )
                    ]
                  : _vm._e(),
                _c("MoviePoster", {
                  staticClass:
                    "w-24 rounded shadow flex-shrink-0 mr-4 desktop:w-64",
                  attrs: { url: _vm.movie.posterUrl }
                })
              ],
              2
            )
          : _vm._e(),
        _c("div", { staticClass: "flex flex-col flex-grow max-h-full" }, [
          _c("div", { staticClass: "flex items-center mb-2" }, [
            _c("h2", { staticClass: "text-xl font-semibold" }, [
              _vm._v(" " + _vm._s(_vm.movie.title) + " "),
              _vm.movie.releaseDate
                ? _c("span", { staticClass: "font-medium text-base" }, [
                    _vm._v(
                      " (" + _vm._s(_vm.movie.releaseDate.getFullYear()) + ") "
                    )
                  ])
                : _vm._e()
            ]),
            _c("div", { staticClass: "flex-grow" }),
            _vm.$ui.desktop || !_vm.movie.posterUrl
              ? _c(
                  "button",
                  {
                    staticClass:
                      "p-2 rounded-lg self-start hover:bg-gray-300 desktop:self-center",
                    attrs: { type: "button" },
                    on: { click: _vm.close }
                  },
                  [
                    _c("BaseIcon", {
                      staticClass: "w-4 h-4 text-gray-800",
                      attrs: { name: "close" }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm.movie.description
            ? _c(
                "p",
                {
                  staticClass:
                    "text-sm text-gray-700 mb-2 leading-relaxed overflow-y-auto"
                },
                [_vm._v(" " + _vm._s(_vm.movie.description) + " ")]
              )
            : _vm._e(),
          _c("div", { staticClass: "flex-grow" }),
          _c(
            "div",
            {
              staticClass:
                "flex justify-end flex-col desktop:flex-row desktop:items-center"
            },
            [
              _c(
                "p",
                { staticClass: "text-sm font-medium ml-0 m-2 desktop:my-0" },
                [_vm._v(" Add it to your collection: ")]
              ),
              _c(
                "div",
                { staticClass: "flex" },
                [
                  _c(
                    "BaseButton",
                    {
                      staticClass:
                        "bg-blue-500 text-white mr-2 hover:bg-blue-700",
                      attrs: {
                        icon: "time",
                        "text-class": "font-semibold text-sm",
                        "icon-class": "w-4 h-4 mr-2"
                      },
                      on: {
                        click: function($event) {
                          _vm.addToCollection(false) && _vm.close()
                        }
                      }
                    },
                    [_vm._v(" watch later ")]
                  ),
                  _c(
                    "BaseButton",
                    {
                      staticClass:
                        "bg-green-500 text-white mr-2 hover:bg-green-700",
                      attrs: {
                        icon: "checkmark",
                        "text-class": "font-semibold text-sm",
                        "icon-class": "w-4 h-4 mr-2"
                      },
                      on: {
                        click: function($event) {
                          _vm.addToCollection(true) && _vm.close()
                        }
                      }
                    },
                    [_vm._v(" watched ")]
                  )
                ],
                1
              )
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }